import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_ARTICLES = "partners";
const BASE_URL = "/api/partners";

const PartnerQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const PARTNER_EMPTY = {title: "", url: "", position: "", fileId: ""};

export function usePartners() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_ARTICLES],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...PartnerQueryConfig
    });
    return {...result, partners: result.data};
}


export function usePartner(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_ARTICLES, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...PartnerQueryConfig
    });
    return {...result, partner: result.data};
}

export function usePartnerMutations() {
    async function createFunction(artice) {
        if (!artice) return;
        return await fetchPOST(BASE_URL, artice, false);
    }

    async function editFunction(partner) {
        if (!partner) return;
        return await fetchPUT(`${BASE_URL}/${partner.id}`, partner);
    }

    async function editAddNewFiles(partner) {
        if (!partner) return;
        return await fetchPUT(`${BASE_URL}/${partner.id}/files`, partner.fileId);
    }

    async function deleteFunction(partner) {
        return await fetchDELETE(`${BASE_URL}/${partner.id}`)
    }

    return {
        createPartner: useMyMutation(createFunction, REACT_QUERY_ID_ARTICLES, partner => `Partner ${partner.title} created`),
        editPartner: useMyMutation(editFunction, REACT_QUERY_ID_ARTICLES, partner => `Partner ${partner.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_ARTICLES, partner => `Partner ${partner.title} modified`),
        deletePartner: useMyMutation(deleteFunction, REACT_QUERY_ID_ARTICLES, partner => `Partner ${partner.title} deleted.`)
    };

}